module.exports = __webpack_public_path__ + "static/media/headquarter-white-icon.88e9ee58.svg";